'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:import');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixImport
     *
     * Web Component that uses an Intersection Observer to fetch additional HTML
     * content and drop it in the DOM when the element is about to be visible.
     *
     * The contract with the server is that the endpoint must return a JSON
     * response with a field named 'html' containing the HTML string to import.
     *
     * @example
     *   <phoenix-import src="/.api/coverlines"></phoenix-import>
     */
    class PhoenixImport extends pageClass.PhoenixElement {
        connectedCallback() {
            this.observeFirstIntersection();
        }

        onFirstIntersection() {
            const src = this.getAttr('src', { required: true });
            const opts = pageClass.basicAuth.getRequestOptions();
            fetch(src, opts)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (data.html !== '') {
                        this.innerHTML = data.html;
                    }
                });
        }
    }
    window.customElements.define('phoenix-import', PhoenixImport);
    measure.end();
});
